export default function ($translate) {
    return {
        KEYS: {
            ACTIVE: 'ACTIVE',
            INACTIVE: 'INACTIVE'
        },
        LABELS: {
            ACTIVE: $translate.instant('formCategory.Active'),
            INACTIVE: $translate.instant('formCategory.Inactive')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/forms/category/forms/index.js